const menu = {
  "member_group": "ユーザー管理",
  "coach_management": "アートシフトコーチ管理",
  "mentor_management": "コーチ担当者管理",
  // Menu labels for the mentor's own screens. Provisional wording — waiting on
  // the confirmed copy from BA.
  "mentor_coach_management": "担当コーチ一覧",
  "mentor_lesson_management": "講座管理",
  "student_management": "受講生管理",
  "function_group": "サービス管理",
  "lesson": "講座管理",
  "setting": "設定",
  "version_management": "公開バージョン",
  "chat": "トーク",
  "manual": "マニュアル",
  "gift": "交換商品管理",
  "graduation": "卒業期管理",
  "plan": "プラン管理",
  "payment_group": "決済管理",
  "payment": "課金管理",
  "user_management": "登録コーチ管理",
}

export default menu;